<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-12 mb-4">
                        <v-card>
                            <v-card-title>
                                Gestion des paiments
                                <v-spacer></v-spacer>
                            </v-card-title>

                            <div class="row">
                                <div class="col-12 mb-4">

                                        <v-tabs v-model="tabs" color="#1C3071" grow >
                                            <v-tab>
                                                En attente
                                            </v-tab>
                                            <v-tab>
                                                Effectué
                                            </v-tab>
                                            <v-tab>
                                                Annuler / Refusé
                                            </v-tab>
                                        </v-tabs>

                                        <v-tabs-items v-model="tabs">
                                            <!--En attente-->
                                            <v-tab-item>
                                                <v-card flat>
                                                    <EnAttente></EnAttente>
                                                </v-card>
                                            </v-tab-item>
                                            <!--Demande Effectuer-->
                                            <v-tab-item>
                                                <v-card flat>
                                                    <v-card-text>
                                                        <Effectuer></Effectuer>
                                                    </v-card-text>
                                                </v-card>
                                            </v-tab-item>
                                            <!--Demande Annuler-->
                                            <v-tab-item>
                                                <v-card flat>
                                                    <v-card-text>
                                                        <Annuler></Annuler>
                                                    </v-card-text>
                                                </v-card>
                                            </v-tab-item>


                                        </v-tabs-items>

                                </div>
                            </div>
                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import EnAttente from "./Paiement/EnAttente";
    import Effectuer from "./Paiement/Effectuer";
    import Annuler from "./Paiement/Annuler";
    export default {
        name: "Paiement",
        components: {Annuler, Effectuer, EnAttente},
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                tabs: null,
                dialog: '',
                id: undefined,
                snackbar: false,
                items: [
                    { state: 'Demande refusée', abbr: 'Demande refusée' },
                    { state: 'Retrait éffectué', abbr: 'Retrait éffectué' },
                    { state: 'Demande confirmée, en attente de paiement', abbr: 'Demande confirmée, en attente de paiement' },
                    { state: 'En attente', abbr: 'En attente' },
                    { state: 'Annuler', abbr: 'Annuler  ' },
                ],
                textSnack: '',
                headers: [
                    {text: 'Pharmacie', value: 'pharmacie_slug'},

                    {
                        text: 'Montant',
                        align: 'start',
                        sortable: true,
                        value: 'montant',
                    },
                    {text: 'Numéro de retrait', value: 'phone_receiver'},
                    {text: 'Balance', value: 'balance_now'},
                    {text: 'Demandé par:', value: 'pharmacie_user_slug'},
                    {text: 'Commentaire', value: 'comment'},
                    {text: 'Etat', value: 'state_ask'},
                    {text: 'Message', value: 'comment_ask_admin'},
                    {text: 'Date de demande', value: 'ask_time'},


                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                libelRules: [
                    v => !!v || 'Commentaire requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],


            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle forme" : "Commentaire"
            }

        }

        ,

        mounted() {

        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,

            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor(){
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>